import React from 'react';
import {Redirect} from 'react-router-dom';

import User from 'Services/User';

/**
 * @function Auth
 * @param {*|JSX.Element} component
 * @return {*|JSX.Element}
 * @constructor
 */
const Auth = ({component}) => {
    const auth = User.loggedIn;

    // if(process.env.MIX_APP_PHASE == 1 && auth) {
    //     return (window.location.pathname === '/profile' || window.location.pathname === '/faq') ? component : <Redirect to="/profile" /> ;
    // } else {
    //     return auth ? component : <Redirect to="/login" />;
    // }

    return auth ? component : <Redirect to="/login" />;
};

export default Auth;
